/* 224 storefront: product-card colour swatches + "+" quick add. Loaded only by the r224 sections/snippets. */
(function () {
  if (window.__r224) return;
  window.__r224 = true;

  var LOW = 5;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function data(card) {
    if (card._r224) return card._r224;
    var el = card.querySelector('script[data-r224-data]');
    var d = { members: [] };
    try { d = JSON.parse(el.textContent); } catch (e) {}
    card._r224 = d;
    return d;
  }

  /* load every colour's pictures once, the first time the pointer or finger reaches a card, so swapping colours is instant */
  function preload(card) {
    if (card._pre) return;
    card._pre = true;
    data(card).members.forEach(function (m) {
      [m.i, m.i2].forEach(function (u) { if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } });
    });
  }

  function closeQA(except) {
    document.querySelectorAll('[data-r224-card].is-qa-open').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-qa-open');
      var qa = c.querySelector('[data-r224-qa]');
      if (qa) { qa.hidden = true; qa.innerHTML = ''; }
    });
  }

  function stockOf(m) {
    var total = 0, tracked = true, any = false;
    m.v.forEach(function (v) {
      if (!v.a) return;
      any = true;
      if (v.q === null || v.q === undefined) tracked = false; else total += v.q;
    });
    return { any: any, tracked: tracked, total: total };
  }

  function setImg(img, url) {
    if (!img || !url || img.getAttribute('src') === url) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.loading = 'eager';
    img.src = url;
  }

  function select(card, idx) {
    var d = data(card), m = d.members[idx];
    if (!m || +card.getAttribute('data-idx') === idx && card._sel === idx) return;
    card._sel = idx;
    card.setAttribute('data-idx', idx);
    var i1 = card.querySelector('[data-r224-img1]'), i2 = card.querySelector('[data-r224-img2]');
    setImg(i1, m.i);
    if (i2) {
      if (m.i2) { setImg(i2, m.i2); i2.style.display = ''; } else { i2.removeAttribute('src'); i2.style.display = 'none'; }
    }
    card.querySelectorAll('[data-r224-link]').forEach(function (a) { a.setAttribute('href', m.u); });
    var nf = card.querySelector('[data-r224-notify]'); if (nf) nf.setAttribute('href', m.u + '#h224-notify');
    var price = card.querySelector('[data-r224-price]'); if (price) price.textContent = m.p;
    var color = card.querySelector('[data-r224-color]'); if (color) color.textContent = m.n;
    card.querySelectorAll('[data-r224-sw]').forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-i') === idx); });
    card.classList.toggle('is-out', !m.a);
    var plus = card.querySelector('[data-r224-plus]'); if (plus) plus.hidden = !m.a;
    var tag = card.querySelector('[data-r224-tag]');
    if (tag) {
      var st = stockOf(m), text = card.getAttribute('data-default-tag') || '';
      if (!m.a) text = 'Sold out';
      else if (st.tracked && st.total > 0 && st.total <= 10) text = 'Only ' + st.total + ' left';
      tag.textContent = text; tag.classList.toggle('is-empty', !text);
    }
    if (card.classList.contains('is-qa-open')) openQA(card);
  }

  function openQA(card) {
    var d = data(card), m = d.members[+card.getAttribute('data-idx')];
    var qa = card.querySelector('[data-r224-qa]');
    if (!m || !qa) return;
    closeQA(card);
    qa.innerHTML = '';
    var head = document.createElement('p'); head.className = 'r224-qa__head'; head.textContent = 'Add a size';
    qa.appendChild(head);
    var list = document.createElement('div'); list.className = 'r224-qa__list';
    m.v.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'r224-qa__size'; b.setAttribute('data-vid', v.id);
      b.textContent = v.s;
      if (!v.a) { b.disabled = true; b.title = 'Sold out'; }
      else if (v.q !== null && v.q !== undefined && v.q <= LOW) { b.title = v.q + ' left'; b.classList.add('is-low'); }
      list.appendChild(b);
    });
    qa.appendChild(list);
    var msg = document.createElement('p'); msg.className = 'r224-qa__msg'; msg.setAttribute('role', 'status'); qa.appendChild(msg);
    qa.hidden = false; card.classList.add('is-qa-open');
  }

  function addToCart(card, btn) {
    var qa = card.querySelector('[data-r224-qa]'), msg = qa && qa.querySelector('.r224-qa__msg');
    var id = +btn.getAttribute('data-vid');
    var T = window.theme || {};
    var mode = (T.settings && T.settings.afterAddToCart) || 'drawer';
    var sectionsToUpdate = ['page-header', 'cart-drawer'].map(function (sel) { return document.querySelector(sel); }).filter(Boolean);
    btn.classList.add('is-busy'); btn.disabled = true;
    // Same request the theme's own Add to cart uses, so the header count and cart drawer refresh the normal way.
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', sectionsToUpdate.map(function (el) { return el.dataset.sectionId; }).join(','));
    fetch((T.routes && T.routes.cartAdd) || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        var data = res.data;
        if (mode === 'page') { setTimeout(function () { window.location.href = (T.routes && T.routes.cart) || '/cart'; }, 300); return; }
        var canPatch = data.sections && sectionsToUpdate.length === Object.keys(data.sections).length && sectionsToUpdate.every(function (el) { return typeof el.updateFromCartChange === 'function'; });
        if (canPatch) {
          sectionsToUpdate.forEach(function (el) { el.updateFromCartChange(data.sections[el.dataset.sectionId]); });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
        closeQA();
        if (mode === 'notification') {
          var tpl = document.getElementById('AddedNotification');
          if (tpl && tpl.content && tpl.content.firstElementChild) {
            var n = tpl.content.firstElementChild.cloneNode(true);
            n.dataset.productTitle = data.product_title;
            (document.querySelector('.pageheader--sticky') || document.body).appendChild(n);
          }
        } else if (mode === 'drawer') {
          var drawer = document.querySelector('.js-cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open(card.querySelector('[data-r224-plus]'));
        }
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id } }));
      })
      .catch(function (err) {
        btn.classList.remove('is-busy'); btn.disabled = false;
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add that size. Please try again.';
      });
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-r224-plus]');
    if (plus) {
      e.preventDefault();
      var c = plus.closest('[data-r224-card]');
      if (c.classList.contains('is-qa-open')) closeQA(); else openQA(c);
      return;
    }
    var size = e.target.closest('.r224-qa__size');
    if (size) { e.preventDefault(); addToCart(size.closest('[data-r224-card]'), size); return; }
    var sw = e.target.closest('[data-r224-sw]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-r224-card]');
      clearTimeout(card._hov);
      preload(card);
      select(card, +sw.getAttribute('data-i'));
      return;
    }
    if (!e.target.closest('[data-r224-qa]')) closeQA();
  });

  /* pointer on a card: warm up the pictures once; pointer on a swatch: switch colour after a short pause so sweeping across swatches stays smooth */
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('[data-r224-card]');
      if (!card) return;
      preload(card);
      var sw = e.target.closest('[data-r224-sw]');
      if (!sw) return;
      var i = +sw.getAttribute('data-i');
      clearTimeout(card._hov);
      card._hov = setTimeout(function () { select(card, i); }, 90);
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest && e.target.closest('[data-r224-sw]');
      if (!sw) return;
      var card = sw.closest('[data-r224-card]');
      if (card && !(e.relatedTarget && sw.contains(e.relatedTarget))) clearTimeout(card._hov);
    });
  } else {
    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest && e.target.closest('[data-r224-card]');
      if (card) preload(card);
    }, { passive: true });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQA(); });
})();
